<template lang="pug">
  div
    ul.nav.mb-3.nav-pills.justify-content-center
      li.nav-item
        RouterLink.nav-link(:to="{ name: 'riders.edit' }" exact) {{ $t('forms.main_fields') }}
      li.nav-item
        RouterLink.nav-link(:to="{ name: 'riders.media.index' }" exact) {{ $t('media.title') }}
    RouterView
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('crumbs', ['crumbs'])
  }
}
</script>

<style lang="sass">
.nav-pills
  .nav-item
    &:first-child .nav-link,
    &:last-child .nav-link,
    .nav-link
      border-radius: 3px !important

    .nav-link
      border: none
      color: #A49E93
      font-weight: normal
      padding: 5px 20px
      margin: 0 10px

      &:hover:not(.active)
        color: #66615b
</style>
